/* eslint-disable @typescript-eslint/indent */
import L from 'leaflet';
import { createControlComponent } from '@react-leaflet/core';
import 'leaflet-routing-machine';
import { render } from 'react-dom';
import ReactDOMServer from 'react-dom/server';
import { FaMapMarkerAlt } from 'react-icons/fa';
import styles from './RoutineMachine.module.scss';

const buildIcon = (color: string) => new L.DivIcon({
    html: ReactDOMServer.renderToString(
        <FaMapMarkerAlt style={{
            fontSize: '30px',
            color,
        }} />
    ),
    className: styles.pin,
    iconAnchor: [15, 30],
    popupAnchor: [1, -34],
});

const RoutingMachineLayer = (props: any) => {
    const { waypoints, renderInfo, hide, loadIconColor } = props;
    const iconCache = new Map<string, L.DivIcon>();
    const getIconColor = (i: number) => {
        if (loadIconColor) {
            return loadIconColor(i)
        }
        return i == 0 ? '#dd1021' : '#1bd44d';
    }
    const getIcon = (i: number) => {
        const color = getIconColor(i);
        let icon = iconCache.get(color);
        if (!icon) {
            icon = buildIcon(color);
            iconCache.set(color, icon);
        }
        return icon;
    }

    const plan = new L.Routing.Plan(waypoints, {
        createMarker: (i, wp, nWps) => {
            if (hide && i > 0 && i < waypoints.length - 1) {
                return false;
            }

            const icon = getIcon(i);

            const marker = L.marker(wp.latLng, { icon: icon, zIndexOffset: i === 0 ? 10 : 0 })
                .bindPopup(() => {
                    const div = document.createElement('div');
                    if (renderInfo) {
                        render(renderInfo(i), div);
                    }
                    return div.innerHTML;
                }, { minWidth: 230, closeButton: false });
            props.setMarkerRef && props.setMarkerRef(i, marker);
            return marker;
        }
    });

    const instance = L.Routing.control({
        waypoints: waypoints,
        show: false,
        autoRoute: false,
        addWaypoints: true,
        routeWhileDragging: false,
        fitSelectedRoutes: true,
        showAlternatives: false,
        plan,
        // lineOptions: { extendToWaypoints: false, missingRouteTolerance: 0, styles: [{ color: 'white', opacity: 0, weight: 9 }] }
    });
    return instance;
};

const RoutingMachine = createControlComponent(RoutingMachineLayer);

export default RoutingMachine;
